const isInvalid = function (password, attribute = 'パスワード') {
  if (password === '') {
    throw new Error(attribute + 'が空です。入力をお願いします。');
  }

  const password_validation = /^(?=.*[A-Z])(?=.*[!-/:-@¥[-`{-~])[a-zA-Z0-9!-/:-@¥[-`{-~]{8,24}$/; //8-24文字かつ(大文字)(小文字)(数字)(記号)をそれぞれ最低1文字以上ずつ使用する
  if (!password_validation.test(password)) {
    throw new Error(attribute + 'の形式が正しくありません。入力し直してください');
  }

  return false;
};

export default { isInvalid };
